import { Navigate } from 'react-router'
import { ReactNode } from 'react'
import { isAuthenticated } from '@/utils/auth'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * 路由守卫组件：保护需要登录的路由
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
